export default __webpack_public_path__ + "static/media/pharmacy.fdb98e7b.svg";